@if (teststufe()) {
  <p class="fe-scope" data-testid="entscheidung-ganzes-release">
    {{ 'testResults.freigabe.entscheidung.wholeRelease' | translate }}
  </p>
}

@if (formOffen()) {
  <div class="fe-recommendation" [attr.data-recommendation]="empfehlung()">
    <div class="fe-recommendation__label">{{ 'testResults.freigabe.bewertung.recommendationLabel' | translate }}</div>
    <div class="fe-recommendation__value">
      {{ 'testResults.freigabe.bewertung.recommendation.' + empfehlung() | translate }}
    </div>
    <div class="fe-recommendation__text">
      {{ recommendationText().key | translate: { count: recommendationText().count } }}
    </div>
  </div>

  @if (aktuell(); as v) {
    <p class="fe-revision">
      {{
        'testResults.freigabe.entscheidung.revision'
          | translate
            : {
                version: v.version,
                entscheidung: 'testResults.freigabe.bewertung.decision.' + v.entscheidung | translate,
                zeit: v.zeitpunkt | date: 'dd.MM.yyyy, HH:mm',
              }
      }}
    </p>
  }

  <div class="fe-decision">
    <div class="fe-sub-label" [id]="idPrefix + '-decision'">
      {{ 'testResults.freigabe.bewertung.decisionLabel' | translate }}
    </div>
    <div class="fe-decision__options" role="group" [attr.aria-labelledby]="idPrefix + '-decision'">
      @for (d of decisions; track d) {
        <button
          type="button"
          class="fe-decision__option"
          [attr.data-decision]="d"
          [attr.data-testid]="'entscheidung-btn-' + d.toLowerCase()"
          [attr.aria-pressed]="entscheid() === d"
          [disabled]="isReadOnly()"
          (click)="waehlen(d)"
        >
          {{ 'testResults.freigabe.bewertung.decision.' + d | translate }}
        </button>
      }
    </div>
    @if (abweichend()) {
      <div class="fe-decision__deviation" [id]="idPrefix + '-deviation'">
        {{ 'testResults.freigabe.bewertung.deviation' | translate }}
      </div>
    }
    <textarea
      class="fe-decision__comment"
      rows="2"
      [attr.maxlength]="commentMax"
      [attr.aria-label]="'testResults.freigabe.bewertung.commentLabel' | translate"
      [attr.aria-describedby]="abweichend() ? idPrefix + '-deviation' : null"
      [attr.aria-invalid]="versuch() && begruendungFehlt() ? 'true' : null"
      [class.fe-field--invalid]="versuch() && begruendungFehlt()"
      [placeholder]="
        isReadOnly()
          ? ''
          : ('testResults.freigabe.bewertung.' + (begruendungPflicht() ? 'placeholderRequired' : 'placeholder')
            | translate)
      "
      [value]="kommentar()"
      [disabled]="isReadOnly()"
      (input)="kommentar.set($any($event.target).value)"
    ></textarea>
    @if (versuch() && begruendungFehlt()) {
      <div class="fe-field-error" role="alert">
        {{ 'testResults.freigabe.entscheidung.validation.reason' | translate }}
      </div>
    }
  </div>

  @if (entscheid() === 'AUFLAGEN') {
    <div class="fe-auflagen">
      <div class="fe-sub-label">{{ 'testResults.freigabe.entscheidung.conditions.title' | translate }}</div>
      <div class="fe-auflagen__list">
        @for (a of auflagen(); track $index; let i = $index) {
          <div class="fe-auflage">
            <input
              class="fe-auflage__text"
              type="text"
              data-testid="auflage-text"
              [attr.maxlength]="conditionMax"
              [attr.aria-label]="'testResults.freigabe.entscheidung.conditions.textLabel' | translate"
              [attr.aria-invalid]="versuch() && auflageFehlt() ? 'true' : null"
              [class.fe-field--invalid]="versuch() && auflageFehlt()"
              [placeholder]="'testResults.freigabe.entscheidung.conditions.placeholder' | translate"
              [value]="a.text"
              (input)="auflageText(i, $any($event.target).value)"
            />
            <app-person-select
              variant="bundle"
              data-testid="auflage-verantwortlich"
              placeholderKey="testResults.freigabe.entscheidung.conditions.responsible"
              [label]="'testResults.freigabe.entscheidung.conditions.responsibleLabel' | translate"
              [options]="mitglieder()"
              [ngModel]="a.wer"
              (ngModelChange)="auflageVerantwortlich(i, $event)"
            />
            <button
              type="button"
              class="fe-auflage__remove"
              data-testid="auflage-entfernen"
              [attr.aria-label]="'testResults.freigabe.entscheidung.conditions.remove' | translate"
              (click)="auflageEntfernen(i)"
            >
              ×
            </button>
          </div>
        }
      </div>
      @if (auflagen().length < conditionsMax) {
        <button type="button" class="fe-link" data-testid="auflage-hinzufuegen" (click)="auflageHinzufuegen()">
          + {{ 'testResults.freigabe.entscheidung.conditions.add' | translate }}
        </button>
      }
      <p class="fe-note">{{ 'testResults.freigabe.entscheidung.conditions.notified' | translate }}</p>
      @if (versuch() && auflageFehlt()) {
        <div class="fe-field-error" role="alert">
          {{ 'testResults.freigabe.entscheidung.validation.condition' | translate }}
        </div>
      }
    </div>
  }

  <ng-container [ngTemplateOutlet]="abnahme" />

  @if (!isReadOnly()) {
    @if (rolleFehlt()) {
      <p class="fe-assign-hint" data-testid="rolle-zuordnen-hinweis">
        {{ 'testResults.freigabe.entscheidung.signoff.assignHint' | translate }}
      </p>
    }
    <p class="fe-note">{{ 'testResults.freigabe.entscheidung.saveHint' | translate }}</p>
    @if (saveError(); as key) {
      <p class="fe-action-error" role="alert">{{ key | translate }}</p>
    }
    <div class="fe-actions">
      <button
        type="button"
        class="fe-save"
        data-testid="entscheidung-speichern"
        [disabled]="!entscheid() || saving() || rolleFehlt()"
        (click)="speichern()"
      >
        <span class="fe-save__icon" aria-hidden="true">✓</span>
        {{ 'testResults.freigabe.bewertung.save' | translate }}
      </button>
      @if (aktuell()) {
        <button type="button" class="fe-secondary" data-testid="entscheidung-abbrechen" (click)="abbrechen()">
          {{ 'testResults.freigabe.entscheidung.cancel' | translate }}
        </button>
      }
    </div>
  }
} @else if (aktuell(); as v) {
  <div class="fe-box" [attr.data-decision]="v.entscheidung">
    <div class="fe-box__head">
      <span class="fe-box__state">
        {{ 'testResults.freigabe.entscheidung.box.' + (vollstaendigBestaetigt() ? 'decided' : 'pending') | translate }}
      </span>
      <span class="fe-box__version">
        <svg class="fe-box__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <path d="M12 3l7 3v5c0 4.5-3 8.2-7 10-4-1.8-7-5.5-7-10V6z" />
        </svg>
        {{ 'testResults.freigabe.entscheidung.box.readonly' | translate: { version: v.version } }}
      </span>
    </div>
    <div class="fe-box__value">{{ 'testResults.freigabe.bewertung.decision.' + v.entscheidung | translate }}</div>
    <div class="fe-box__meta">
      {{
        'testResults.freigabe.entscheidung.box.by'
          | translate: { name: v.autor.name, zeit: v.zeitpunkt | date: 'dd.MM.yyyy, HH:mm' }
      }}
      @if (v.abweichend && v.empfehlung) {
        {{
          'testResults.freigabe.entscheidung.box.deviates'
            | translate: { empfehlung: 'testResults.freigabe.bewertung.recommendation.' + v.empfehlung | translate }
        }}
      }
    </div>
  </div>

  <div class="fe-folge">
    <svg class="fe-folge__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M7 3v3M17 3v3M4 9h16M5 5h14a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1z" />
    </svg>
    <span>{{ folgeKey() | translate: { bestaetigt: anzahlBestaetigt(), gesamt: anzahlRollen } }}</span>
  </div>

  @if (v.kommentar) {
    <div class="fe-reason">
      <div class="fe-sub-label">{{ 'testResults.freigabe.entscheidung.reason' | translate }}</div>
      <div class="fe-reason__text">{{ v.kommentar }}</div>
    </div>
  }

  @if (v.auflagen.length > 0) {
    <div class="fe-conditions">
      <div class="fe-sub-label fe-conditions__title">
        {{ 'testResults.freigabe.entscheidung.conditions.titleCount' | translate: { count: v.auflagen.length } }}
      </div>
      @for (a of v.auflagen; track $index) {
        <div class="fe-condition">
          <span class="fe-condition__box" aria-hidden="true"></span>
          <span class="fe-condition__text">{{ a.text }}</span>
          <span class="fe-condition__who">{{ a.verantwortlichName ?? '—' }}</span>
        </div>
      }
      <p class="fe-note fe-conditions__hint">
        {{ 'testResults.freigabe.entscheidung.conditions.notified' | translate }}
      </p>
    </div>
  }

  <ng-container [ngTemplateOutlet]="abnahme" />

  <div class="fe-actions">
    <button type="button" class="fe-primary" data-testid="protokoll-exportieren" (click)="protokollExportieren.emit()">
      <span aria-hidden="true">↓</span>
      {{ 'testResults.freigabe.entscheidung.export' | translate }}
    </button>
    @if (!isReadOnly()) {
      <button type="button" class="fe-secondary" data-testid="entscheidung-revidieren" (click)="revidieren()">
        <span aria-hidden="true">↺</span>
        {{ 'testResults.freigabe.entscheidung.revise' | translate }}
      </button>
    }
  </div>

  @if (fruehere().length > 0) {
    <div class="fe-history">
      <button
        type="button"
        class="fe-link"
        data-testid="verlauf-toggle"
        [attr.aria-expanded]="verlaufOffen()"
        (click)="verlaufOffen.set(!verlaufOffen())"
      >
        {{ verlaufOffen() ? '▾' : '▸' }}
        {{
          'testResults.freigabe.entscheidung.' + (fruehere().length === 1 ? 'history' : 'historyMany')
            | translate: { count: fruehere().length }
        }}
      </button>
      @if (verlaufOffen()) {
        @for (e of fruehere(); track e.version) {
          <div class="fe-history__row">
            <span class="fe-history__version">V{{ e.version }}</span>
            <span class="fe-history__decision" [attr.data-decision]="e.entscheidung">
              {{ 'testResults.freigabe.bewertung.decision.' + e.entscheidung | translate }}
            </span>
            <span class="fe-history__text">
              {{ e.autor.name }} · {{ e.zeitpunkt | date: 'dd.MM.yyyy, HH:mm' }}
              @if (e.kommentar) {
                — {{ e.kommentar }}
              }
            </span>
          </div>
        }
      }
    </div>
  }
}

<ng-template #abnahme>
  <div class="fe-signoffs">
    <div class="fe-sub-label">{{ 'testResults.freigabe.bewertung.signoffTitle' | translate }}</div>
    @for (z of signoffZeilen(); track z.rolle + '-' + auswahlStand()) {
      @let rolle = 'testResults.freigabe.bewertung.role.' + z.rolle | translate;
      <div class="fe-signoff" [attr.data-testid]="'signoff-' + z.rolle">
        @if (z.name) {
          <app-avatar [name]="z.name" [size]="24" />
        } @else {
          <span class="fe-signoff__avatar-empty" aria-hidden="true"></span>
        }
        <span class="fe-signoff__who">
          <span class="fe-signoff__name" [class.fe-signoff__name--empty]="!z.name">
            {{ z.name ?? ('testResults.freigabe.bewertung.unassigned' | translate) }}
          </span>
          <span class="fe-signoff__role">
            {{ rolle }}
            @if (z.benachrichtigt) {
              · {{ 'testResults.freigabe.entscheidung.signoff.notified' | translate }}
            }
          </span>
        </span>
        @if (z.bestaetigtAm) {
          <span class="fe-signoff__status" data-confirmed="true">✓ {{ z.bestaetigtAm | date: 'dd.MM.yyyy' }}</span>
        } @else if (z.fehlt) {
          <span class="fe-signoff__status" data-missing="true">
            {{ 'testResults.freigabe.entscheidung.signoff.assignRole' | translate }}
          </span>
        } @else if (z.bestaetigbar) {
          <button
            type="button"
            class="fe-signoff__confirm"
            [disabled]="confirming()"
            [attr.aria-label]="'testResults.freigabe.bewertung.confirmAria' | translate: { rolle }"
            (click)="bestaetigen(z.rolle)"
          >
            {{ 'testResults.freigabe.bewertung.confirm' | translate }}
          </button>
        } @else if (z.benachrichtigt) {
          <span class="fe-signoff__status">{{ 'testResults.freigabe.bewertung.pending' | translate }}</span>
        }
      </div>
      @if (z.auswahl) {
        <app-person-select
          class="fe-signoff__select"
          variant="bundle"
          [attr.data-testid]="'signoff-select-' + z.rolle"
          [label]="rolle"
          [options]="rollenOptionen()"
          [allowNone]="z.leerErlaubt"
          [ngModel]="z.inhaberId"
          (ngModelChange)="zuordnen(z, $event)"
        />
      }
    }
    @if (darfZuordnen() && mitgliederFehler()) {
      <p class="fe-action-error" role="alert" data-testid="mitglieder-fehler">
        {{ 'testResults.freigabe.entscheidung.errors.membersFailed' | translate }}
      </p>
    }
    @if (assignError(); as key) {
      <p class="fe-action-error" role="alert" data-testid="zuordnung-fehler">{{ key | translate }}</p>
    }
    @if (confirmError(); as key) {
      <p class="fe-action-error" role="alert">{{ key | translate }}</p>
    }
  </div>
</ng-template>
